import { formatDate } from './formatter';

const getCompanyDetailsAsString = (company) => {
  const details = `
  Company Name: ${company.CompanyName}
  Company Number: ${company.CompanyNumber}
  Status: ${company.Status}
  Company Type: ${company.CompanyType}
  
  Incorporation Date: ${formatDate(company.IncorporationDate)}
  Confirmation Due: ${formatDate(company.ConfirmationDueDate)}
  Accounts Due: ${formatDate(company.AccountsDueDate)}
  
  Registered Address:
  ${company.RegisteredAddress.street}
  ${company.RegisteredAddress.city}
  ${company.RegisteredAddress.postalCode}
  ${company.RegisteredAddress.country}
  
  Tax Registrations:
  Corporation Tax: ${company.Tax.corporationTaxRegistered ? 'Registered' : 'Not Registered'}
  VAT: ${company.Tax.vatRegistered ? 'Registered' : 'Not Registered'}
  PAYE: ${company.Tax.payeRegistered ? 'Registered' : 'Not Registered'}
  
  Share Structure:
  Total Shares: ${company.ShareStructure?.statementOfCapital?.totalShares}
  Total Capital: £${company.ShareStructure?.statementOfCapital?.totalAmount}
  ${company.ShareStructure?.shareClasses
    ?.map(
      (sc) => `
    ${sc.type} Shares: ${sc.totalShares} @ £${sc.valuePerShare} each
    Voting Rights: ${sc.votingRights ? 'Yes' : 'No'}
  `
    )
    .join('')}
  
  Officers:
  ${company.Officers?.directors
    ?.map(
      (d) => `
    ${d.name} (Director)
    Appointed: ${formatDate(d.appointedOn)}
    Nationality: ${d.nationality}
  `
    )
    .join('')}
  ${company.Officers?.secretaries
    ?.map(
      (s) => `
    ${s.name} (Secretary)
    Appointed: ${formatDate(s.appointedOn)}
  `
    )
    .join('')}
  `;

  return details;

  // navigator.clipboard.writeText(details)
  //     .then(() => alert('Company details copied to clipboard!'))
  //     .catch(() => alert('Failed to copy details'));
};

export { getCompanyDetailsAsString };
